export const DEBUG = false;
export const MAIN_URL = 'https://liveness.enface.ai';

export const FACE_CUT_SCALE = 1.5;
export const FACE_CUT_SHIFT_Y = 0.15;
export const FACE_CUT_MIN_SIDE = 150;
/* old version with movement
export const FACE_MIN_HEIGHT = 45; // % from screen
export const FACE_MAX_HEIGHT = 50; // % from screen
export const FACE_MIN_WIDTH = 45; // % from screen
export const FACE_MIN_WIDTH = 45; // % from screen
export const FACE_MAX_WIDTH = 60; // % from screen
export const FACE_MAX_SHIFT_X = 20; // % from bbox width
export const FACE_MAX_SHIFT_Y = 50; // % from bbox height
*/
export const FACE_MAX_HEIGHT = 50; // % from screen
export const FACE_MIN_WIDTH = 50; // % from screen
export const FACE_MAX_WIDTH = 60; // % from screen
export const FACE_MAX_SHIFT_X = 5; // % from bbox width
export const FACE_MAX_SHIFT_Y = 30; // % from bbox height
export const WRONG_POSITION_DEBOUNCE = 4;
export const MIN_SMOOTH_FPS = 10;
export const DISTANCE_TO_COMPLETE = 15;
export const COLOR_BORDER_WAITING = '#94969c';
export const COLOR_BORDER_OK = '#2dcd7a';
export const COLOR_BORDER_BAD = '#f84953';

export const EFFECTIVE_COEFF = 1;
export const RADIUS_PROPORTION = 6;
export const ACTION_TIMEOUT = 20;
export const LIVENESS_UNAVAILABLE = 1;
export const LIVENESS_LOADING = 2;
export const LIVENESS_IN_PROCESS = 3;
export const HOLE_WH_COEFF = 1.5;
export const HOLE_W_COEFF = 1.2;
// const OFFSET_Y = isMobile() ? -30 : 20;
export const OFFSET_Y = 0;
export const PROMPT_INITIAL = {
  isOk: false,
  message: ['Поместите лицо в овал'],
};

export const ANGLE_MAX_YAW = 20;
export const ANGLE_MAX_ROLL = 10;
export const SUCCESS_POSITION_TIMEOUT = 3;
